const key = 'ab-test-page';
const abTestPagePath = 'pages/ab-';

export class AbTestCustomAttributes {
  static get = () => window.sessionStorage.getItem(key) === 'true';

  static add = () => {
    if (window.location.pathname.includes(abTestPagePath)) {
      window.sessionStorage.setItem(key, 'true');
    }
  };
}
